<span>Sorted By:</span>
<!-- <p-dropdown class="ms-3 text-start" [options]="selectedSortCols" placeholder="Relevancy"> -->
<p-select class="ms-3 text-start" [options]="selectedCols" placeholder="Relevancy" [(ngModel)]="selectedSortColumn"
    optionLabel="header">
</p-select>
<p-select class="ms-1 text-start" [options]="sortDirectionOptions" optionLabel="name"
    [(ngModel)]="selectedSortDirection">
</p-select>
<button class="ms-2 mb-1 btn btn-primary" (click)="customSort()">Apply</button>
<button *ngIf="showSortReset" class="ms-2 mb-1 btn btn-primary" (click)="resetSort()">Reset</button>